import { ParticipanteRequest } from "../models/participantes";
import { deleteSeguroDeudor, getDeudor, getDeudorJuridico, getMontoAsegurado, updateDeudor, updateDeudorJuridico } from "../services/servicesDeudores";
import { Deudor } from "../models/deudor";
import { SeguroDeudorEdit } from "../models/seguroDeudorEdit";
import { getSeguroDeudor, getSegurosDeudor } from "../services/servicesSeguros";
import { EliminarSeguroDeudor, SeguroDeudor } from "../models/seguroDeudor";
import { AxiosResponse } from "axios";
import { DeudorJuridico } from "../models/deudorJuridico";
import { Dominios, enumTipoSeguro, StatusCode } from "../../../utils/enums";
import { getValoresDominio } from "../../../services/servicesDominio";
import { selectorTransversal } from "../../../dtos/selector";
import { useState } from "react";
import { useToast } from "../../../hooks/useToast";
import { ListResponseDto } from "../../../dtos/ListResponseDto";

export function useDeudor() {

    const [tipoSeguros, setTipoSeguros] = useState<selectorTransversal[]>([]);
    const [montoAseguradoCalculado, setMontoAseguradoCalculado] = useState<number>(0);
    const [defaultValues, setDefaultValues] = useState<SeguroDeudorEdit>({
        mutuoId: 0,
        seguroId: 0,
        tipoSeguro: '',
        codigoPoliza: '',
        codigoInterno: '',
        tasa: 0,
        montoPrimaAnual: 0,
        montoAsegurado: 0,
        mesesGratuidad: 0,
        nombreCompania: null,
        montoPrimaDividendo: 0,
        cantidadCuotasAnuales: 12,
        tasaSobrePrima: 0,
        deudaDirecta: 100,
        deudaSeguro: 100,
        mesesGracia: null,
    });
    const { addToast } = useToast();


    const obtenerDeudor = async (dataRequest: ParticipanteRequest): Promise<Deudor | void> => {

        const resp: AxiosResponse = await getDeudor(dataRequest)
        if (resp.status === StatusCode.Ok) {
            const dataDeudor: Deudor = await resp.data

            return dataDeudor;
        }
    }

    const obtenerDeudorJuridico = async (dataRequest: ParticipanteRequest): Promise<DeudorJuridico | void> => {

        const resp: AxiosResponse = await getDeudorJuridico(dataRequest)
        if (resp.status === StatusCode.Ok) {
            const dataDeudorJuridico: DeudorJuridico = await resp.data;

            return dataDeudorJuridico;
        }
    }

    const obtenerSegurosDeudor = async (mutuoId: number) => {

        const resp: AxiosResponse<ListResponseDto<SeguroDeudor>> = await getSegurosDeudor(mutuoId)
        if (resp.status === StatusCode.Ok) {
            const respuesta: SeguroDeudor[] = resp.data.items;

            return respuesta;
        }
    }

    const obtenerSeguroDeudor = async (mutuoId: number, seguroId: number): Promise<SeguroDeudorEdit | void> => {

        const resp: AxiosResponse = await getSeguroDeudor(mutuoId, seguroId)
        if (resp.status === StatusCode.Ok) {
            const dataSeguro: SeguroDeudorEdit = await resp.data;

            return dataSeguro;
        }
    }

    const actualizarDeudor = async (deudor: Deudor): Promise<void> => {
        const response: AxiosResponse = await updateDeudor(deudor);
    }

    const actualizarDeudorJuridico = async (deudor: DeudorJuridico): Promise<void> => {

        await updateDeudorJuridico(deudor);
    }

    const obtenerTiposSeguros = async () => {
        const resp: AxiosResponse<ListResponseDto<selectorTransversal>> = await getValoresDominio(Dominios.TIPO_SEGURO)

        if (resp && resp.status === 200) {
            setTipoSeguros(resp.data.items);
        }

        return;
    }

    const obtenerMontoAsegurado = async (mutuoId: number, tipoSeguro: string) => {
        const montoAsegurado: number = await getMontoAsegurado(mutuoId, tipoSeguro);
        setMontoAseguradoCalculado(montoAsegurado);
    }

    const eliminarSeguro = async (dataDelete: EliminarSeguroDeudor, renderizar: () => void) => {
        const resp: AxiosResponse = await deleteSeguroDeudor(dataDelete);
        if (resp.status === StatusCode.NoContent) {
            renderizar();
            addToast({
                mostrar: true,
                titulo: 'Confirmación',
                tipo: 'Success',
                mensaje: 'El seguro ha sido eliminado correctamente.'
            });

        }
    }

    return {
        obtenerDeudor,
        obtenerDeudorJuridico,
        obtenerSegurosDeudor,
        obtenerSeguroDeudor,
        actualizarDeudor,
        actualizarDeudorJuridico,
        obtenerTiposSeguros,
        eliminarSeguro,
        obtenerMontoAsegurado,
        tipoSeguros,
        defaultValues,
        montoAseguradoCalculado
    }
}

